import React from 'react';
import { useTranslation } from 'react-i18next';
import { snapchatIntegrationUrl } from '../../../constants/integrationConstants';
import useGetOrganizationSettings from '../../../apiHooks/queries/useGetOrganizations';
import {
  ORGANIZATION_SETTINGS,
} from '../../../constants/pageIdentifiers';
import { Colors } from '../../../constants/constants';
import SecondaryButton from '../../../components/buttons/secondaryButton';

const SnapchatPanel = () => {
  const { t } = useTranslation();

  const { data } = useGetOrganizationSettings(ORGANIZATION_SETTINGS);
  const organizationSettings = data?.data?.data;

  if (organizationSettings && organizationSettings.isSnapchatActive) {
    return (
      <div className="flex w-full flex-col items-end">
        <div className="flex w-full flex-1 justify-between rounded-xl border p-4">
          <div className="flex items-center justify-center gap-3 text-xs font-medium text-primary">
            <div>{t('accountStatus')}</div>
            <SecondaryButton
              style={{
                border: `1px solid ${Colors.green}`,
                color: Colors.green,
                height: '40px',
                fontSize: 14,
              }}
            >
              {t('active')}
            </SecondaryButton>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-between gap-5 rounded-xl border p-4">
      <div className="flex flex-col gap-2 text-primary">
        <span className="text-sm font-semibold">Connect to Snapchat</span>
        <p className="text-sm font-normal">
          Here you can link your Snapchat account with Digger for more efficient tracking.
        </p>
      </div>
      <button
        type="button"
        className="flex items-center gap-2.5 rounded-lg bg-primary px-5 py-2
        text-sm text-white duration-200 focus:outline-[1px] focus:outline-offset-[3px]
        focus:outline-primary/50 enabled:hover:bg-[#0a3a4b]
        enabled:active:bg-opacity-80 disabled:opacity-50"
        onClick={() => {
          window.location.href = snapchatIntegrationUrl;
        }}
      >
        Connect to Snapchat
      </button>
    </div>
  );
};

export default SnapchatPanel;
